import { use, useEffect, useState } from "react";
import { usePlan } from "../_providers/PlanProvider";
import InviteController from "../controllers/InviteController";
import Invite from "../models/Invite";
import { useAuth } from "../_providers/AuthProvider";
import CategoryController from "../controllers/CategoryController";
import Category from "../models/Category";
import PlanController from "../controllers/PlanController";
import { useModal } from "../_providers/ModalProvider";
import { ConfirmationModal } from "../_modals/ConfirmationModal";
import TransactionController from "../controllers/TransactionController";
import InviteWidget from "../_widgets/InviteWidget";
import PendingInvite from "../_widgets/PendingInvite";
import ReceivedInvite from "../_widgets/ReceivedInvite";
import IncomeCategoriesWidget from "../_widgets/IncomeCategoriesWidget";
import ExpenseCategoryWidget from "../_widgets/ExpenseCategoriesWidget";
import ProjectMembersWidget from "../_widgets/ProjectMembersWidget";

const SettingsPage = () => {
    return (
        <div>
            <h1>Settings</h1>
            <div style={{display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", paddingBottom: 70}}>
                <InviteWidget/>
                <PendingInvite />
                <ProjectMembersWidget/>
                <IncomeCategoriesWidget/>
                <ExpenseCategoryWidget/>
            </div>
        </div>
    );
}
export default SettingsPage;